import React, { useState } from 'react';

import { graphql } from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { debounce, filter, get, noop } from 'lodash';

import { ChipLoader } from 'components/v2';

import FiltersSelectHeader from '../FiltersSelectHeader';

import { FilterInsuranceQuery } from './__generated__/FilterInsuranceQuery.graphql';
import FilterInsuranceList from './FilterInsuranceList';

interface FilterInsuranceProps {
  type?: string;
}

const FilterInsurance: React.FC<FilterInsuranceProps> = ({ type = 'insurance' }) => {
  const [filteredResult, setFilteredResult] = useState<any[] | undefined>();

  // Hard Coded Limit since this query has no pagination
  const data = useLazyLoadQuery<FilterInsuranceQuery>(
    graphql`
      query FilterInsuranceQuery {
        planNames: insuranceUniquePlanNamesMany(limit: 5000)
      }
    `,
    {},
  );

  const planNames = get(data, 'planNames', []) as any[];

  const handleOnSearchChange = (search: string) => {
    if (search === '') {
      setFilteredResult(planNames);
    } else {
      const filtered = filter(planNames, (item: string) => item.toLowerCase().includes(search.toLowerCase()));
      setFilteredResult(filtered);
    }
  };

  return (
    <React.Fragment>
      <FiltersSelectHeader items={planNames} type={type} onSearchChange={debounce(handleOnSearchChange, 600)} />
      <FilterInsuranceList type={type} data={filteredResult || planNames} />
    </React.Fragment>
  );
};

// TODO: Create a ChipLoaderBlock components
export default (props: FilterInsuranceProps) => (
  <React.Suspense
    fallback={
      <>
        <FiltersSelectHeader type={'insurance'} onSearchChange={noop} />
        <div style={{ marginLeft: 16 }}>
          <ChipLoader />
        </div>
      </>
    }
  >
    <FilterInsurance {...props} />
  </React.Suspense>
);
